import type { ReactNode } from 'react';
import { useNavigate } from 'react-router';
import { Button } from '@/components/ui/button';

/**
 * One header action — the common icon (+ optional label) button injected into
 * AppHeader's `actions`. `to` navigates via the router; otherwise `onClick`
 * runs (e.g. window.open for external Docs/Support, or a sign-out handler).
 * Rich header widgets (notification bell, profile menu) are passed to AppHeader
 * as their own nodes instead of through this helper.
 */
export function HeaderButton({
  icon,
  label,
  to,
  onClick,
}: {
  icon: ReactNode;
  label?: string;
  to?: string;
  onClick?: () => void;
}) {
  const navigate = useNavigate();
  return (
    <Button
      variant="ghost"
      size="sm"
      className="gap-1.5 text-muted-foreground"
      aria-label={label}
      onClick={to ? () => navigate(to) : onClick}
    >
      {icon}
      {label ? <span className="hidden md:inline">{label}</span> : null}
    </Button>
  );
}
